/* unplugin-vue-components disabled */import script from "./CenterContent.vue?vue&type=script&setup=true&lang=js"
export * from "./CenterContent.vue?vue&type=script&setup=true&lang=js"

import "./CenterContent.vue?vue&type=style&index=0&id=3d650d87&lang=scss&scoped=true"

import exportComponent from "D:\\pangu_artificial_intelligence_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d650d87"]])

export default __exports__